/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import {
    Input,
    Spin,
    Form,
    Card,
    Button,
    Modal,
    message,
    Upload,
    Icon,
    Modal as AntModal,
    DatePicker,
    Switch,
    InputNumber,
} from 'antd';
import './index.less';
import { services } from '@comall-backend-builder/core';
import { isArray, isEmpty, isString } from 'lodash';
import { DESIGN_PAGE_LINK_TYPES_LIST } from '../../constants/page-design';
import { HotZoneEditor } from '../hot-zone-editor';
import moment from 'moment';
import { errorHandle } from '../../services';
const { TextArea } = Input;
const { confirm } = Modal;
const { RangePicker } = DatePicker;

const FloatingLayerAddCom: React.FC<any> = ({ form, params = {} }) => {
    const [spinning, setSpinning] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState<any>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const [backPic, setBackPic] = useState(''); // 图片地址
    const [hotZoneList, setHotZoneList] = useState<any[]>([]);
    const [datail, setDetail] = useState<any>({});
    const [imgWh, setImgWh] = useState<any>({});
    const id = params.id ?? '';
    const readonly = !!Number(params.readonly);

    // 获取详情
    const handleGetDetail = () => {
        setSpinning(true);
        services.api
            .get({}, { apiPath: `/page/floatingLayer/${id}` })
            .then((res: any) => {
                setDetail(res);
                const {
                    createTime,
                    enabled,
                    name,
                    floatDescribe,
                    orders,
                    picUrl,
                    startTime,
                    endTime,
                    config,
                } = res;
                const fileListData = picUrl
                    ? [{ uid: '-1', name: '浮层.png', status: 'done', url: picUrl }]
                    : [];
                setFileList(fileListData);
                setBackPic(picUrl);
                const effectiveDate = [moment(startTime), moment(endTime)];
                form.setFieldsValue({
                    createTime,
                    enabled: enabled === 0 ? true : false,
                    name,
                    floatDescribe,
                    orders,
                    effectiveDate,
                    picUrl: fileListData,
                });
                let configJson: any = {};
                if (config && isString(config)) {
                    try {
                        configJson = JSON.parse(config);
                    } catch (error) {}
                }
                if (!isEmpty(configJson)) {
                    const hotZoneListData = isArray(configJson?.hotZoneList)
                        ? configJson?.hotZoneList
                        : [];
                    setTimeout(() => {
                        setHotZoneList(hotZoneListData);
                        setSpinning(false);
                    }, 500);
                } else {
                    setSpinning(false);
                }
            })
            .catch((e: any) => {
                setSpinning(false);
                errorHandle(e);
            });
    };

    useEffect(() => {
        if (id) {
            handleGetDetail();
        } else {
            const today = moment().format('YYYY-MM-DD');
            form.setFieldsValue({
                createTime: today,
            });
        }
    }, []);

    const goBack = () => {
        services.navigation.goto('/design/floatingLayer');
    };

    // 保存or编辑
    const handleSave = (e: React.FormEvent, type: string) => {
        e.preventDefault();
        form.validateFields((err: any, values: any) => {
            console.log(err, values);
            if (err) {
                message.warning('请先把必填项填写完整！');
                return;
            }
            let startTime = '';
            let endTime = '';
            const { name, floatDescribe, effectiveDate, enabled, orders } = values;
            if (isArray(effectiveDate) && effectiveDate.length) {
                startTime = effectiveDate[0].format('YYYY-MM-DD HH:mm:ss');
                endTime = effectiveDate[1].format('YYYY-MM-DD HH:mm:ss');
            }
            const serveParams = {
                name,
                floatDescribe,
                enabled: enabled ? 0 : 1,
                orders: orders || 1,
                startTime,
                endTime,
                config: JSON.stringify({ hotZoneList: hotZoneList, imgWh }),
                picUrl: backPic,
            };
            let draft = 0;
            if (type === 'submit' || datail?.draft === 1) {
                draft = 1;
            }
            if (id) {
                services.api
                    .put({ ...serveParams, id, draft }, { apiPath: `/page/floatingLayer/${id}` })
                    .then(() => {
                        message.success('编辑成功！');
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            } else {
                services.api
                    .post({ ...serveParams, draft }, { apiPath: `/page/floatingLayer/add` })
                    .then(() => {
                        message.success('新增成功！');
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            }
        });
    };

    // 删除
    const showDeleteConfirm = () => {
        confirm({
            title: '确定要删除吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                services.api
                    .delete({}, { apiPath: `/page/floatingLayer/${id}` })
                    .then(() => {
                        message.success('删除成功！');
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const handleBeforeUpload: any = (file) => {
        return new Promise((resolve, reject) => {
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                message.error(`图片${file.name}超出限制，最大上传 10MB 图片`);
                setFileList([]);
                reject();
            } else {
                resolve(file);
            }
        });
    };

    const handlePreview = async (e: any) => {
        setPreviewImage(e.url || e.thumbUrl);
        setShowPreview(true);
    };

    const getImageSize = (imageUrl: string, callback: Function) => {
        const img = new Image();
        img.onload = function() {
            const width = img.width;
            const height = img.height;
            callback(null, width, height);
        };
        img.onerror = function() {
            callback('Failed to load image', null, null);
        };
        img.src = imageUrl;
    };

    const handleChange = (e: any) => {
        if (e.file.status === 'done') {
            message.success('上传成功1个，上传失败0个');
            const cur = e.fileList[0] || {};
            if (cur?.response?.path) {
                getImageSize(cur?.response?.path, (err: any, width: any, height: any) => {
                    if (!err) {
                        setBackPic(`${cur?.response?.path}?width=${width}&height=${height}`);
                    } else {
                        setBackPic('');
                    }
                });
            } else {
                setBackPic('');
            }
        } else if (e.file.status === 'error') {
            message.success('上传成功0个，上传失败1个，请重新上传!');
            setTimeout(() => {
                form.setFieldsValue({ picUrl: undefined });
                setFileList([]);
            }, 20);
        }
        setFileList(e.fileList);
        if (!(isArray(e.fileList) && e.fileList.length)) {
            setTimeout(() => {
                form.setFieldsValue({ picUrl: undefined });
                setFileList([]);
            }, 20);
        }
    };

    const uploadButton = (
        <div>
            <Icon type="plus" />
            <div className="ant-upload-text">上传</div>
        </div>
    );

    const uploadMsg = (
        <div className="uploadMsg">
            <span>支持jpg/png/gif 格式，图片尺寸建议为</span>
            <br />
            <span>180px*180px</span>
        </div>
    );

    const handleEditHotZone = (flag: boolean) => {
        if (!backPic) {
            message.warning('请先上传图片！');
            return;
        }
        if (flag) {
            const hotVisible = !!backPic && backPic.includes('https');
            setVisible(hotVisible);
        } else {
            setVisible(false);
        }
    };

    const handleChangeHot = (value: any) => {
        const newHotZoneList = value.hotZoneList || [];
        const imgWhData = value.imgWh;
        setImgWh(imgWhData);
        setHotZoneList(newHotZoneList);
    };

    const { getFieldDecorator } = form;
    return (
        <>
            <Card title={readonly ? '查看首页浮层' : id ? '编辑首页浮层' : '新增首页浮层'}>
                <Spin spinning={spinning}>
                    <div className="floating-layer-add">
                        <Form
                            className="ant-advanced-search-form"
                            style={{ marginBottom: '24px' }}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 12 }}
                        >
                            <Form.Item label="名称">
                                {getFieldDecorator('name', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入名称',
                                        },
                                    ],
                                })(<Input disabled={readonly} placeholder="请输入名称" />)}
                            </Form.Item>
                            <Form.Item label="创建日期">
                                {getFieldDecorator('createTime')(
                                    <Input disabled placeholder="创建日期" />
                                )}
                            </Form.Item>
                            <Form.Item label="生效日期">
                                {getFieldDecorator('effectiveDate', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择生效日期',
                                        },
                                    ],
                                })(<RangePicker disabled={readonly} showTime />)}
                            </Form.Item>

                            <Form.Item label="目标描述">
                                {getFieldDecorator('floatDescribe', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入备注内容',
                                        },
                                    ],
                                })(
                                    <TextArea
                                        disabled={readonly}
                                        placeholder="请输入备注内容"
                                        rows={4}
                                    />
                                )}
                            </Form.Item>
                            <div className="upload-image">
                                <Form.Item label="图片">
                                    {getFieldDecorator('picUrl', {
                                        rules: [{ required: true, message: '请上传图片' }],
                                    })(
                                        <Upload
                                            disabled={readonly}
                                            accept="image/*"
                                            name="fileName"
                                            action={`${ENV.API_ROOT}/images`}
                                            listType="picture-card"
                                            fileList={fileList}
                                            beforeUpload={handleBeforeUpload}
                                            onPreview={handlePreview}
                                            onChange={handleChange}
                                        >
                                            {fileList.length >= 1 ? null : uploadButton}
                                        </Upload>
                                    )}
                                    {uploadMsg}
                                </Form.Item>
                            </div>

                            <Form.Item label="编辑热区">
                                <Button
                                    onClick={() => {
                                        if (!readonly) {
                                            handleEditHotZone(true);
                                        }
                                    }}
                                >
                                    添加/调整热区
                                </Button>
                                <div style={{ color: '#F2A861' }}>
                                    当前创建了{hotZoneList.length}个热区
                                </div>
                            </Form.Item>

                            <Form.Item label="是否启用">
                                {getFieldDecorator('enabled', { valuePropName: 'checked' })(
                                    <Switch
                                        disabled={readonly}
                                        checkedChildren="启用"
                                        unCheckedChildren="禁用"
                                    />
                                )}
                            </Form.Item>

                            <Form.Item label="位置排序">
                                <div className="sort-box">
                                    {getFieldDecorator('orders')(
                                        <InputNumber
                                            disabled={readonly}
                                            width={200}
                                            placeholder="请输入位置排序"
                                            min={1}
                                            max={9999}
                                        />
                                    )}
                                    <div style={{ marginLeft: 12 }}>数字越大排序越靠前</div>
                                </div>
                            </Form.Item>

                            <Form.Item
                                style={{ marginTop: 36 }}
                                wrapperCol={{ span: 12, offset: 9 }}
                            >
                                {!(datail?.draft === 1) && !readonly ? (
                                    <Button
                                        type="primary"
                                        onClick={(e) => {
                                            confirm({
                                                title: '确定要提交吗？',
                                                okText: '确定',
                                                cancelText: '取消',
                                                onOk() {
                                                    handleSave(e, 'submit');
                                                },
                                                onCancel() {},
                                            });
                                        }}
                                    >
                                        提交
                                    </Button>
                                ) : null}

                                {!readonly ? (
                                    <Button
                                        style={{ marginLeft: 12 }}
                                        type={datail?.draft === 1 ? 'primary' : 'default'}
                                        onClick={(e) => {
                                            handleSave(e, 'save');
                                        }}
                                    >
                                        保存
                                    </Button>
                                ) : null}

                                {id && datail?.draft === 0 && !readonly && (
                                    <Button style={{ marginLeft: 12 }} onClick={showDeleteConfirm}>
                                        删除
                                    </Button>
                                )}

                                <Button style={{ marginLeft: 12 }} onClick={goBack}>
                                    返回
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Spin>

                <AntModal
                    visible={showPreview}
                    footer={null}
                    width={500}
                    style={{ textAlign: 'center' }}
                    onCancel={() => {
                        setShowPreview(false);
                        setPreviewImage('');
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <img style={{ width: '100%' }} src={previewImage} alt="" />
                    </div>
                </AntModal>

                <HotZoneEditor
                    form={form}
                    wrapName={'entry'}
                    result={'hotZoneList'}
                    linkTypes={DESIGN_PAGE_LINK_TYPES_LIST}
                    visible={visible}
                    maxCount={20}
                    linkTypeMode="select"
                    imgUrl={backPic}
                    hotZoneList={hotZoneList}
                    onChange={(value) => {
                        handleChangeHot(value);
                    }}
                    onClose={() => handleEditHotZone(false)}
                    isFormTrigger={true}
                />
            </Card>
        </>
    );
};

export const FloatingLayerAdd = Form.create<any>()(FloatingLayerAddCom);
export default FloatingLayerAdd;
